import spinner from '../Spinner-2.gif'

const Spinner = () => {
    return ( 
        <>
        <img src={spinner}
        alt="Loading..."
        style={{ width: '100px', margin: ' 40px auto', display: 'block' }}/>
        </>
     );
}
 
export default Spinner;